export default "__VITE_ASSET__830496a7__"